import React from 'react';
import Template from './Template';

export default (props) => (
  <Template
    {...props}
    src="/Ahmad.png"
    name="Ahmad Kamal Sheikh Awab "
    position="Chief Executive Officer (CEO)"
    description={(
      <div>
        <p>
          Ahmad Kamal is CEO of Premium Capital Partners, bringing with him over 33 years of
          experience in high-level banking and business management roles for global financial
          institutions. He also takes up position on the Supervisory Board.
        </p>
        <p>
          As a respected industry veteran, Ahmad Kamal will be in charge of the oversight of
          corporate affairs and strategic and financial planning for Premium Capital Partners. His
          impressive industry expertise follows an exemplary track record in areas of credit and
          risk management, capital markets, corporate finance, and a wide range of financial markets
          and transaction roles for leading global organisations such as Citibank, ABN Amro Bank,
          Qatar Commercial Bank, and Deutsche Bank.
        </p>
        <p>
          More recently Ahmad Kamal held the position of Senior General Manager of Malaysia Nasional
          Insurance Berhad. He later went on to perform key corporate advisory roles for Leverage3
          International Limited, before providing us the benefit of his extensive experience in
          joining Premium Capital Partners in 2017.
        </p>
      </div>
    )}
    quote="This isn't just about building a great business, it's about building great relationships. That means the more positive relationships we have, the greater the success for the business."
  />
)


// WEBPACK FOOTER //
// ./src/screens/OurTeam/Ahmad.js